export const PAGE_SIZE = 20;
export const EMPLOYEE_INFO_REGEX =
  /^(?:\d+|[A-Za-z0-9]+|[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@[A-Za-z0-9.-]+\.[A-Za-z]{2,})$/;
